import { take } from 'rxjs/operators';
export function takeFirstEmitted(observable) {
    return new Promise((resolve, reject) => {
        observable.pipe(take(1)).subscribe((x) => resolve(x), err => reject(err));
    });
}
//# sourceMappingURL=take_first_emitted.js.map